import { cn } from '@/utils/tailwind-util';
import React from 'react';

interface Props extends Record<string, any> {
  isCircle?: boolean;
  className?: string;
}

const Placeholder: React.FC<Props> = ({ isCircle, className, ...rest }) => (
  <div
    className={cn(
      'w-full h-full bg-gray-200 animate-pulse',
      isCircle ? 'rounded-full' : 'rounded',
      className
    )}
    {...rest}
  ></div>
);

export default Placeholder;
